import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Collapse } from "reactstrap";
import { ProfileIntroTitle } from "../../../../../constants";
import { ProfileInfoList, SocialNetworkList } from "../../../../../data/applications/SocialApp";
import HeaderWithIcon from "../HeaderWithIcon";

const ProfileInfoCard = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card>
      <HeaderWithIcon Heading={ProfileIntroTitle} isOpen={isOpen} setIsOpen={setIsOpen} />
      <Collapse isOpen={isOpen}>
        <CardBody className="filter-cards-view">
          {ProfileInfoList.map((data, index) => (
            <Fragment key={index}>
              <span className="f-w-500 mb-2 d-block">{data.title} :</span>
              <p>{data.paragraph}</p>
            </Fragment>
          ))}
          <div className="social-network theme-form">
            <span className="f-w-500">Social Networks</span>
            {SocialNetworkList.map((item, index) => (
              <Link to={`https://www.${item.link}.com/`} target="_blank" key={index}>
                <Button color="transparent" className={`social-btn btn-${item.class} mb-2 text-center`}>
                  <i className={`fa fa-${item.link} m-r-5`} />
                  {item.text}
                </Button>
              </Link>
            ))}
          </div>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default ProfileInfoCard;